import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Traslates, SimpleLoading } from "../../pures";
import "./grid-list-request-detail.css";

/* === Custom Component for th elements of the Grid === */
const signerCellHeader = (props) => {
  const cellHeaderStyles = {
    color: "#123513",
    fontSize: "14px",
    fontWeight: 600,
    display: "flex",
    justifyContent: "start",
    fontFamily: "Quicksand",
  };
  return <span style={cellHeaderStyles}>{props.title}</span>;
};

/* === Custom componente for td elements of the Grid === */
const signerCell = (props) => {
  const cellItemStyles = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 550,
    fontFamily: "Quicksand",
  };
  return <td style={cellItemStyles}>{props.dataItem[props.field]}</td>;
};

/* === Custom componente cells SignStatus for td elements of the Grid === */
const signerStatusSignCell = (props) => {
  let colorItem = "";
  if (props.dataItem.signStatusId) {
    if (props.dataItem.signStatusId === 2) {
      colorItem = "#005EA0";
    } else if (props.dataItem.signStatusId === 4) {
      colorItem = "#899232";
    } else if (props.dataItem.signStatusId === 3) {
      colorItem = "#F86A65";
    } else if (props.dataItem.signStatusId === 5) {
      colorItem = "#FF922C";
    } else {
      colorItem = "#4c4c4c";
    }
  }
  const cellItemStyles = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 550,
    textTransform: "uppercase",
    fontFamily: "Quicksand",
  };
  return (
    <td style={cellItemStyles}>
      <span style={{ color: `${colorItem}` }}>
        {props.dataItem[props.field]}
      </span>
    </td>
  );
};

const GridListRequestDetail = (props) => {
  const { t } = useTranslation();
  const gridLabelNorecordsStyles = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 500,
    fontFamily: "Quicksand",
  };
  return (
    <div>
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Traslates>
          <Grid
            className="request-detail"
            data={props.signRequestSigners.slice(
              props.skip,
              props.take + props.skip
            )}
            resizable
            reorderable
          >
            <GridColumn
              field="name"
              title={t("gridListSigners.titleName")}
              width="auto"
              cell={signerCell}
              headerCell={signerCellHeader}
            />
            <GridColumn
              field="email"
              title={t("gridListSigners.titleEmail")}
              width="auto"
              cell={signerCell}
              headerCell={signerCellHeader}
            />
            <GridColumn
              field="signStatusName"
              title={t("gridListSigners.titleSignStatus")}
              width="auto"
              cell={signerStatusSignCell}
              headerCell={signerCellHeader}
            />
            <GridNoRecords>
              <p style={gridLabelNorecordsStyles}>
                {t("gridListSigners.noDataToShow")}
              </p>
            </GridNoRecords>
          </Grid>
        </Traslates>
      )}
    </div>
  );
};
export { GridListRequestDetail as default };
